export async function uploadToCloudinary(file, folder = "afriport/products") {
  const CLOUD = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
  const PRESET = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET || "afriport_unsigned";
  
  // Validate environment variables
  if (!CLOUD) {
    throw new Error("❌ Cloudinary not configured: REACT_APP_CLOUDINARY_CLOUD_NAME is missing");
  }
  
  console.log("🚀 Uploading to Cloudinary...", { CLOUD, PRESET, folder });
  
  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", PRESET);
  formData.append("folder", folder);
  
  try {
    const res = await fetch(`https://api.cloudinary.com/v1_1/${CLOUD}/image/upload`, {
      method: "POST",
      body: formData,
    });
    
    const data = await res.json();
    
    if (!res.ok) {
      console.error("❌ Cloudinary error:", data);
      throw new Error(data.error?.message || `Cloudinary error: ${res.status}`);
    }
    
    console.log("✅ Upload successful!", { url: data.secure_url });
    return { url: data.secure_url, publicId: data.public_id };
  } catch (err) {
    console.error("❌ Upload failed:", err);
    throw new Error(`Image upload failed: ${err.message}`);
  }
}

export async function uploadMultiple(files, folder) {
  return Promise.all(Array.from(files).map((f) => uploadToCloudinary(f, folder)));
}
